import { Injectable } from '@angular/core';
import { HttpClient  } from '@angular/common/http';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DeviceInfo } from '../interfaces/device-info';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {

constructor(private _http:HttpClient, private _device:DeviceDetectorService) { }

public getIPAddress()  
  {  
    return this._http.get("https://api.ipify.org/?format=json");  
  }

  public logDevice(){

    if(!localStorage.getItem("seesion_id")){
      var devInfo:DeviceInfo = this._device.getDeviceInfo();
      devInfo.client_UTC = new Date(Date.now()).toUTCString();
      devInfo.client_timestamp = new Date(Date.now()).toLocaleString();
      this.getIPAddress().subscribe((res: any) => {
        devInfo.ip_address = res.ip;
        this._http.post('/user/device', devInfo).toPromise().then( (res:any) =>{
          localStorage.setItem("seesion_id", res); 
        });
      }
      );
      console.log(devInfo);
    }
  }
}
